import Cookies from "js-cookie";
import moment from "moment";

export const getCachedData = (key) => {
  try {
    let localData = null;
    try {
      localData = localStorage.getItem(key);
    } catch (localStorageError) {}

    if (localData) {
      const parsedItem = JSON.parse(localData);

      if (parsedItem.expiry && moment(parsedItem.expiry).isBefore(moment())) {
        try {
          localStorage.removeItem(key);
        } catch (e) {}
        return null;
      }

      return parsedItem.data;
    }

    const cachedItem = Cookies.get(key);
    if (!cachedItem) return null;

    const parsedItem = JSON.parse(cachedItem);
    if (parsedItem.expiry && moment(parsedItem.expiry).isBefore(moment())) {
      Cookies.remove(key);
      return null;
    }

    return parsedItem.data;
  } catch (error) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
    Cookies.remove(key);
    return null;
  }
};

export const setCacheData = (key, data, expirationInSeconds) => {
  const expiry = moment().add(expirationInSeconds, "seconds").toISOString();
  const valueToStore = JSON.stringify({ data, expiry });

  try {
    try {
      localStorage.setItem(key, valueToStore);
    } catch (e) {}
  } catch (e) {
    if (valueToStore.length < 3500) {
      Cookies.set(key, valueToStore, { path: "/" });
    }
  }
};
